import { useApi } from './useApi';

export function useCountry() {
  const { fetchData, data, error, loading } = useApi();

  const getCountriesApi = async (params = { page: 1, limit: -1 }) => {
    try {
      const result = await fetchData('/api/countries', { params });

      return {
        success: true,
        data: result
      };
    } catch (err) {
      return {
        success: false,
        error: err.message || 'Lỗi kết nối'
      };
    }
  };

  return { getCountriesApi, data, error, loading };
}
